import { Box, Switch, SxProps, Theme, TypographyProps } from "@mui/material";
import useMergedSx from "../../../../../hooks/useMergedSx.ts";
import TypographyWithTooltip from "../../../TypographyWithTooltip.tsx";

export interface SwitchFieldProps {
  checked?: boolean;
  label: string;
  tooltipText?: string;
  typographyProps?: TypographyProps;
  containerSx?: SxProps<Theme>;
  onChange: (newValue: boolean) => void;
  disabled?: boolean;
}

const SwitchField = ({
  checked,
  onChange,
  label,
  tooltipText,
  typographyProps,
  containerSx,
  disabled,
}: SwitchFieldProps) => {
  const mergedContainerSx = useMergedSx(
    {
      display: "flex",
      flex: 1,
      justifyContent: "space-between",
      flexDirection: "row",
    },
    containerSx
  );

  return (
    <Box sx={mergedContainerSx}>
      <TypographyWithTooltip label={label} tooltipText={tooltipText} typographyProps={typographyProps} />
      <Switch checked={checked} onClick={() => onChange(!checked)} disabled={disabled} />
    </Box>
  );
};

export default SwitchField;
